import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { _AbcTreeComponent, _AbcTreeNode } from '@barthauer/abc/ui-components';
import { ItemClickEvent } from 'devextreme/ui/drop_down_button';

import { FilterOption } from '@barthauer/abc/queries/opath/core';
import { HeaderButton } from 'libs/abc/queries/opath/core/src/lib/viewModels/layout.viewModel';
import { Subject } from 'rxjs';
import { OPathFunction, OPathFunctionCategory, OPathFunctions } from '../../models/function.model';
import { TranslationConfiguration } from '../../models/view.model';
import { FunctionService } from '../../services/function.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'expressions-editor-function',
  templateUrl: './function.component.html',
  styleUrls: ['./function.component.scss'],
})
export class FunctionComponent implements OnInit, OnDestroy {
  @Output() onOPathFunctionSelected: EventEmitter<OPathFunction> = new EventEmitter<OPathFunction>();
  @Output() ontoggleFunction: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(_AbcTreeComponent, { static: false }) treeComponent: _AbcTreeComponent;

  public oPathFunctions: OPathFunctions;
  public functionButtons: HeaderButton[] = [];
  public rootTreeNodes: _AbcTreeNode<OPathFunction>[];
  private _showFunctionsPermanently: boolean = false;
  set showFunctionsPermanently(value: boolean) {
    this._showFunctionsPermanently = value;
    this.refreshButtonsState();
  }
  get showFunctionsPermanently(): boolean {
    return this._showFunctionsPermanently;
  }

  public translation: TranslationConfiguration;
  public currentFilterOption: FilterOption | undefined;
  searchValue: string;
  public searchResult: _AbcTreeNode<OPathFunction>[];
  private unsubscribe$: Subject<void> = new Subject<void>();
  constructor(private sharedService: SharedService, private functionService: FunctionService) {
    this.translation = sharedService.translation;
  }

  ngOnInit(): void {
    this.oPathFunctions = this.functionService.oPathFunctions;
    this.rootTreeNodes = this.assignDataToTree(this.oPathFunctions?.Categories);
    this.searchResult = [...this.rootTreeNodes];
    this.refreshButtonsState();
  }

  public filterOptionChanged(filterOption: FilterOption): void {
    this.currentFilterOption = filterOption;
    this.rootTreeNodes = this.assignDataToTree(this.oPathFunctions.Categories);
    this.searchResult = [...this.rootTreeNodes];
  }

  public searchTermChanged(searchTerm: string): void {
    this.searchValue = searchTerm;
    if (this.searchValue.length === 0) {
      this.treeComponent.instance.collapseAll();
    }
  }

  public handleFunctionSelected(event: ItemClickEvent): void {
    if (event.itemData.children.length === 0) {
      this.onOPathFunctionSelected.emit(event.itemData.data);
    }
  }

  public toggleShowFunctionsPermanently(): void {
    this.showFunctionsPermanently = !this.showFunctionsPermanently;
    this.ontoggleFunction.emit(this.showFunctionsPermanently);
  }

  private assignDataToTree(categories: OPathFunctionCategory[]): _AbcTreeNode<OPathFunction>[] {
    let tree = [];

    categories?.forEach((category) => {
      let categoryNode = new _AbcTreeNode<OPathFunction>();
      categoryNode.children = [];
      categoryNode.caption = category.designation;

      categoryNode.icon = 'formula';
      categoryNode.data = new OPathFunction();

      category.Functions.forEach((_function) => {
        let functionNode = new _AbcTreeNode<OPathFunction>();
        functionNode.caption = _function.name;
        functionNode.icon = 'formula';
        functionNode.data = new OPathFunction(_function);
        functionNode.data.description = _function.description;
        functionNode.children = [];
        categoryNode.children.push(functionNode);
      });

      tree.push(categoryNode);
    });

    return tree;
  }

  public refreshButtonsState(): void {
    this.functionButtons = [
      {
        icon: 'pin',
        toolTipContent: this.translation?.pin,
        statfullButton: true,
        active: this.showFunctionsPermanently,
        action: async () => this.toggleShowFunctionsPermanently(),
      },
    ];
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
